module.exports = __webpack_public_path__ + "img/marvel-banner.1b50973c.jpg";